import React from "react"
// import AniLink from "gatsby-plugin-transition-link/Link"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { FaLinkedinIn, FaFacebookF, FaEnvelope } from "react-icons/fa"
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import "./footer.scss"

export const Footer = ({ classTitle }) => {
  return (
    <>
      <footer className="footer-container">
        <div className="location-container">
          <div className="footer-logo-container">
            <StaticImage
              src="../../images/home/footer/Skol-icono-escritorio.svg"
              alt="footer-logo-skol"
              className="logo-normal"
              placeholder="tracedSVG"
            />
            <StaticImage
              src="../../images/home/footer/Skol-imagotipo-web-escritotio_Logo Blanco.svg"
              alt="footer-logo-skol-tablet"
              className="logo-blanco"
              placeholder="blurred"
            />
          </div>
          <div className="footer-location-text-container">
            <h5>Uruguay - Argentina - Colombia</h5>
            <small>
              © Copyright {new Date().getFullYear()}. All Rights Reserved.
            </small>
            <p>
              <FaEnvelope /> info@skolsolutions.com
            </p>
          </div>
        </div>

        <div className="footer-nav-container">
          <ul className="list-unstyled footer-navbar-nav">
            <li className="footer-nav-item ">
              <Link className="footer-nav-link nav-link" to="/quienes-somos">
                Quienes somos
              </Link>
            </li>
            <UncontrolledDropdown
              className="footer-nav-item"
              nav
              inNavbar
              direction="up"
            >
              <DropdownToggle nav className={`${classTitle}-nav-link`}>
                Soluciones
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Link
                    to="/soluciones/salas-multimedia"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Salas Multimedia
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/videoconferencia"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Videoconferencia
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/automatizacion"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Automatización
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/videowall"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Videowall / Display
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/sonorizacion"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Sonorización
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/mobiliario"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Mobiliario
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soluciones/proyectores"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Proyectores
                  </Link>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>

            <UncontrolledDropdown
              className="footer-nav-item"
              nav
              inNavbar
              direction="up"
            >
              <DropdownToggle nav className={`${classTitle}-nav-link`}>
                Soporte
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Link
                    to="/soporte/servicios"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Servicios
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link
                    to="/soporte/planes"
                    className={`${classTitle}-dropdown-nav-link nav-link`}
                  >
                    Planes
                  </Link>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <li className="footer-nav-item">
              <Link className="footer-nav-link nav-link" to="/clientes">
                Cliente
              </Link>
            </li>
            <li className="footer-nav-item">
              <Link className="footer-nav-link nav-link" to="/contacto">
                Contacto
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-soluciones-container">
          <ul className="list-unstyled">
            <li className="footer-soluciones-logos salas-logo-container">
              <Link
                className="footer-nav-link"
                to="/soluciones/salas-multimedia"
              >
                <StaticImage
                  src="../../images/home/footer/SALAS MULTIMEDIA-BLANCO.svg"
                  alt="salas-logo"
                  placeholder="tracedSVG"
                />
              </Link>
            </li>
            <li className="footer-soluciones-logos videoConf-logo-container">
              <Link
                className="footer-nav-link"
                to="/soluciones/videoconferencia"
              >
                <StaticImage
                  src="../../images/home/footer/VIDEO-COMFERENCIA-BLANCO.svg"
                  alt="videoConf-logo"
                  placeholder="tracedSVG"
                />
              </Link>
            </li>

            <li className="footer-soluciones-logos sincro-logo-container">
              <Link className="footer-nav-link" to="/soluciones/sonorizacion">
                <StaticImage
                  src="../../images/home/footer/SINCRO AMBIENTE-BLANCO.svg"
                  alt="sincro-logo"
                  placeholder="tracedSVG"
                />
              </Link>
            </li>
            <li className="footer-soluciones-logos proyector-logo-container">
              <Link className="footer-nav-link" to="/soluciones/proyectores">
                <StaticImage
                  src="../../images/home/footer/PROYECTOR-BLANCO.svg"
                  alt="proyector-logo"
                  placeholder="tracedSVG"
                />
              </Link>
            </li>
            <li className="footer-soluciones-logos automa-logo-container">
              <Link className="footer-nav-link" to="/soluciones/automatizacion">
                <StaticImage
                  src="../../images/home/footer/AUTOMATIZACIÓN-BLANCO.svg"
                  alt="automa-logo"
                  placeholder="tracedSVG"
                />
              </Link>
            </li>
            <li className="footer-soluciones-logos videowall-logo-container">
              <Link className="footer-nav-link" to="/soluciones/videowall">
                <StaticImage
                  src="../../images/home/footer/VIDEO-WALL-BLANCO.svg"
                  alt="videowall-logo"
                  placeholder="tracedSVG"
                />
              </Link>
            </li>
            <li className="footer-soluciones-logos mobiliario-logo-container">
              <Link className="footer-nav-link" to="/soluciones/mobiliario">
                <StaticImage
                  src="../../images/home/footer/MOBILIARIO-BLANCO.svg"
                  alt="mobiliario-logo"
                  placeholder="tracedSVG"
                />
              </Link>
            </li>
          </ul>
        </div>

        <div className="wrap-social">
          <div className="footer-social-container">
            <ul className="list-unstyled">
              <li className="footer-nav-item pr-1 linkedin">
                <a
                  className="linkedin-nav-link"
                  href="https://www.linkedin.com/company/skol-solutions/"
                >
                  <FaLinkedinIn className="linkedin-footer-logo" />
                </a>
              </li>
              <li className="footer-nav-item pr-1 facebook">
                <a className="fb-nav-link" href="https://www.facebook.com/">
                  <FaFacebookF className="fb-footer-logo" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  )
}
